import HeroMblOctPink from '../../assets/img/hero-caro-mbl-new-october.png';
import HeroMblNewOne from '../../assets/img/hero-caro-mbl-new-1.png';
import HeroMblNewTwo from '../../assets/img/hero-caro-mbl-new-2.png';
import HeroMblNewThree from '../../assets/img/hero-caro-mbl-new-3.png';
import HeroMblNewFour from '../../assets/img/hero-caro-mbl-new-4.png';

import Carousel from 'react-multi-carousel';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useState, useEffect } from 'react';
import axios from 'axios';

const DEFAULT_MBL_BANNERS = [
  { id: 'm-oct-pink', name: 'Breast Cancer Awareness 5% Discount - #CheckOnHer', image: HeroMblOctPink, action_type: 'none' },
  { id: 'm1', name: 'AmarLab Diagnostics', image: HeroMblNewOne, action_type: 'none' },
  { id: 'm2', name: 'AmarLab Home Sample Collection', image: HeroMblNewTwo, action_type: 'none' },
  { id: 'm3', name: 'AmarLab Report Summary', image: HeroMblNewThree, action_type: 'none' },
  { id: 'm4', name: 'AmarLab Special Offers', image: HeroMblNewFour, action_type: 'none' },
];

const extractYouTubeId = (url) => {
  if (!url) return '';
  const trimmed = url.trim();
  const embedMatch = trimmed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/);
  if (embedMatch) return embedMatch[1];
  const watchMatch = trimmed.match(/[?&]v=([a-zA-Z0-9_-]+)/);
  if (watchMatch) return watchMatch[1];
  const shortMatch = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (shortMatch) return shortMatch[1];
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;
  return trimmed;
};

const getYouTubeEmbedUrl = (url, fallback = 'https://www.youtube.com/embed/Gv4zcpaTTvY') => {
  const id = extractYouTubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : fallback;
};

const HeroCarouselMbl = () => {
  const { postActivity } = useContext(AuthContext);
  const [banners, setBanners] = useState(DEFAULT_MBL_BANNERS);
  const [videoUrl, setVideoUrl] = useState('https://www.youtube.com/embed/Gv4zcpaTTvY');
  const [hasVideo, setHasVideo] = useState(true);

  useEffect(() => {
    let isMounted = true;
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/banner-get/?banner_type=web-home-mobile&is_active=true&ordering=sorting`
      )
      .then((res) => {
        if (isMounted && res.data && res.data.results && res.data.results.length > 0) {
          setBanners(res.data.results);
        }
      })
      .catch((err) => {
        console.warn('HeroCarouselMbl: Using default bundled mobile banners', err);
      });

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/banner-get/?banner_type=web-home-video&is_active=true&ordering=sorting`
      )
      .then((res) => {
        if (isMounted && res.data && res.data.results && res.data.results.length > 0) {
          const vidBanner = res.data.results[0];
          const embedUrl = getYouTubeEmbedUrl(vidBanner.target_action);
          if (embedUrl) {
            setVideoUrl(embedUrl);
            setHasVideo(true);
          }
        }
      })
      .catch((err) => {
        console.warn('HeroCarouselMbl: Using default YouTube video', err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleBannerClick = (banner) => {
    postActivity('banner', banner.name || 'Mobile Hero Banner', window.location.href);
    if (banner.action_type === 'url' && banner.target_action) {
      window.open(banner.target_action, '_blank', 'noopener,noreferrer');
    } else if (banner.target_action) {
      window.location.href = banner.target_action;
    }
  };

  return (
    <Carousel
      additionalTransfrom={0}
      arrows={false}
      autoPlay={true}
      autoPlaySpeed={5000}
      centerMode={false}
      className=''
      containerClass='container carousel-container'
      dotListClass=''
      draggable
      focusOnSelect={false}
      infinite
      itemClass='test'
      keyBoardControl
      minimumTouchDrag={80}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 1024,
          },
          items: 1,
          partialVisibilityGutter: 40,
        },
        mobile: {
          breakpoint: {
            max: 464,
            min: 0,
          },
          items: 1,
          partialVisibilityGutter: 30,
        },
        tablet: {
          breakpoint: {
            max: 1024,
            min: 464,
          },
          items: 1,
          partialVisibilityGutter: 30,
        },
      }}
      showDots={true}
      sliderClass=''
      slidesToSlide={1}
      swipeable
    >
      {banners.map((item, idx) => (
        <div
          key={item.id || idx}
          className='imagel'
          style={{ cursor: item.target_action ? 'pointer' : 'default' }}
          onClick={() => handleBannerClick(item)}
        >
          <img
            src={item.image}
            alt={item.name || 'AmarLab Diagnostics'}
            className='img-fluid'
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = HeroMblNewOne;
            }}
          />
        </div>
      ))}
      {hasVideo && videoUrl && (
        <div
          className='imagel w-100 h-100'
          onClick={() =>
            postActivity('banner', 'Youtube Video', window.location.href)
          }
        >
          <div className='w-100 h-100' style={{ overflow: 'hidden' }}>
            <iframe
              width='100%'
              height='100%'
              src={videoUrl}
              title='YouTube video player'
              frameBorder={0}
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
              loading='lazy'
            />
          </div>
        </div>
      )}
    </Carousel>
  );
};

export default HeroCarouselMbl;
